import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setOnboardingPma } from "store/pma/action";
import PageHeader from "./components/header";
import Receipt from "./components/receipt";

const PmaReceipt = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pmaOnboarding = useSelector((state) => state?.pmaReducer?.onboarding);
  const searchParams = new URLSearchParams(location?.search);
  const params = Object.fromEntries(searchParams.entries());
  const onClose = () => {
    dispatch(
      setOnboardingPma({
        ...pmaOnboarding,
        ...params,
        amount: +params?.amount,
        onb_uuid: params?.onb_id,
      })
    );
    navigate("/pma/onboarding", { replace: true });
  };

  return (
    <div className="items-center pma-layout !bg-gray--12 max-w-2xl  w-full m-auto flex flex-col h-[100vh]">
      <PageHeader title={""} onClose={onClose} />
      <div className="w-full max-w-2xl pt-12">
        <div className="overflow-auto overflow-x-hidden pb-24">
          <Receipt {...params} onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

export default PmaReceipt;
